export default "__VITE_ASSET__CMDIwdij__"